// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3s5uz","alert":"SettungsInbox_alert__1Psja"};